import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { ICustomContentWidgets } from "."
import { ICustomContentWidget } from "../../models"
import { customContentWidgetsAPI } from "../../apis"
import { addErrorNotification } from "../notifications/actions"
import { GlobalState } from "../../store"
import { Exceptions } from "../../util/Translations"

export const customContentWidgetsSlice = createSlice({
    name: "customContentWidgets",

    initialState: {
        customContentWidgets: {},
        isLoading: false,
        isInitialized: false,
        workspaceId: null,
    } as ICustomContentWidgets,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomContentWidgets.pending, (state, action) => {
                state.isLoading = true
                state.workspaceId = action.meta.arg
            })
            .addCase(fetchCustomContentWidgets.rejected, (state) => {
                state.isLoading = false
            })
            .addCase(fetchCustomContentWidgets.fulfilled, (state, action) => {
                const customContentWidgetsArray = action.payload
                const customContentWidgets: Record<
                    string,
                    ICustomContentWidget
                > = {}

                customContentWidgetsArray.forEach((customContentWidget) => {
                    if (!!customContentWidget.id) {
                        customContentWidgets[
                            customContentWidget.id.toString()
                        ] = customContentWidget
                    }
                })

                state.isInitialized = true
                state.isLoading = false
                state.customContentWidgets = customContentWidgets
            })
    },
})

export default customContentWidgetsSlice.reducer

export const fetchCustomContentWidgets = createAsyncThunk(
    "customContentWidgets/fetchCustomContentWidgets",
    async (workspaceId: number | null, { dispatch }) => {
        let customContentWidgets: ICustomContentWidget[] = []

        try {
            const response =
                await customContentWidgetsAPI.getCustomContentWidgets(
                    workspaceId,
                )
            customContentWidgets = response.data
        } catch (error) {
            console.error(error)
            dispatch(
                addErrorNotification(
                    Exceptions.AnErrorOccurredWhileFetchingCustomContentWidgets,
                ),
            )
        }

        return customContentWidgets
    },
    {
        // only do it if it's not initialized yet
        condition: (_, { getState }) => {
            const {
                customContentWidgets: { isInitialized },
            } = getState() as GlobalState
            return !isInitialized
        },
    },
)
